// Use special chars in dublicates inside e.g. src/config/letters/russian.ts
export const REPLACEMENT_MAP: Record<string, string> = {
  'Æ': 'Я',
};
